// src/pages/Pocetna.js
import React from "react";
import PocetnaBaner from "./Pocetna/PocetnaBaner";
import SectionNavbar from "../components/NavigacijaSekcije";
import PrvaSekcija from "./Pocetna/PrvaSekcija";
import Onama from "./Pocetna/Onama";
import Vijesti from "./Pocetna/Vijesti";
import Obavijesti from "./Pocetna/Obavijesti";
import Projekti from "./Pocetna/Projekti";
import { Outlet } from "react-router-dom";
import DekanatIzjave from "./Pocetna/DekanatIzjave";
import Ciklusi from "./Pocetna/Ciklusi";

import Odsjeci from "./Pocetna/Odsjeci";
import Kontakt from "./Pocetna/Kontakt";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import NaucnoIstrazivackiRadComponent from "./Pocetna/NaucnoIstrazivackiRad/NaucnoIstrazivackiRad";

function Pocetna() {
  const bannerRef = useRef(null);
  const { t } = useTranslation();

  const items = [
    { nameKey: "navbarPocetna.aboutUs", link: "#onama" },
    { nameKey: "navbarPocetna.news", link: "#novosti" },
    { nameKey: "navbarPocetna.announcements", link: "#obavjestenja" },
    { nameKey: "navbarPocetna.projects", link: "#projekti" },
    { nameKey: "navbarPocetna.research", link: "#naucnostIstrazivackiRad" },
    { nameKey: "navbarPocetna.deansWord", link: "#rijeciuprave" },
    { nameKey: "navbarPocetna.cycles", link: "#ciklusi" },
    { nameKey: "navbarPocetna.departments", link: "#odsjeci" },
    { nameKey: "navbarPocetna.contact", link: "#kontakt" },
  ];

  return (
    <div>
      <Helmet>
        <title>{t("pocetna.metaTitle")}</title>
        <meta
          name="description"
          content={t("pocetna.metaDescription")}
        />

        <link
          rel="canonical"
          href="https://www.mef.unsa.ba/"
        />

        <meta
          property="og:title"
          content={t("pocetna.metaTitle")}
        />
        <meta
          property="og:description"
          content={t("pocetna.metaDescription")}
        />
        <meta
          property="og:image"
          content="https://www.mef.unsa.ba/logo220.png"
        />
        <meta
          property="og:url"
          content="https://www.mef.unsa.ba/"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Mašinski fakultet Univerziteta u Sarajevu" />
      </Helmet>

      <div ref={bannerRef}>
        <PocetnaBaner />
      </div>
      <SectionNavbar items={items} observeRef={bannerRef} />
      <PrvaSekcija bg={"bg-light"} />
      <Onama bg={"bg-white"} />
      <Vijesti bg={"bg-light"} />
      <Obavijesti bg={"bg-white"} />
      <Projekti bg={"bg-light"} />
      <NaucnoIstrazivackiRadComponent bg={"bg-white"} />
      <DekanatIzjave bg={"bg-light"} />
      <Ciklusi bg={"bg-white"} />
      <Odsjeci bg={"bg-light"} />
      <Kontakt bg={"bg-white"} />
      <Outlet />
    </div>
  );
}

export default Pocetna;
